import { api } from '@utils/ky.util';

export const sendToPrinter = async (chat_id, printer_id) => {
  return await api
    .post('send_to_printer_accum', {
      json: { chat_id, printer_id },
    })
    .json();
};
